module.exports = __webpack_public_path__ + "files/5afc30279d9394ec1c7f048b909a8b0f.png";